var _title, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVisibilityOff = function SvgVisibilityOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "visibility-off")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.813 12h0.188c2.188 0 4 1.813 4 4v0.25zM10.063 13.063c-0.438 0.875-0.75 1.875-0.75 2.938 0 3.688 3 6.688 6.688 6.688 1.063 0 2.063-0.313 2.938-0.75l-2.063-2.063c-0.25 0.063-0.563 0.125-0.875 0.125-2.188 0-4-1.813-4-4 0-0.313 0.063-0.625 0.125-0.875zM2.688 5.688l1.688-1.688 23.625 23.625-1.688 1.688c-1.499-1.48-3.008-2.95-4.5-4.438-1.813 0.75-3.75 1.125-5.813 1.125-6.688 0-12.375-4.125-14.688-10 1.063-2.625 2.813-4.875 5-6.625-1.219-1.218-2.416-2.459-3.625-3.688zM16 9.313c-0.875 0-1.688 0.188-2.438 0.5l-2.875-2.875c1.625-0.625 3.438-0.938 5.313-0.938 6.688 0 12.313 4.125 14.625 10-1 2.5-2.563 4.625-4.563 6.313l-3.875-3.875c0.313-0.75 0.5-1.563 0.5-2.438 0-3.688-3-6.688-6.688-6.688z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisibilityOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visibility-off.aa835e1d.svg";
export { ForwardRef as ReactComponent };